import { isFuture } from "date-fns";

import type { EventListItemApiView } from "~~/model/event.model";

export type EventFilters = {
  exclude?: DatabaseTable<"course_sessions">["id"][];
  from?: string;
  to?: string;
  sortOrder?: "ASC" | "DESC";
  sortField?: string;
};

export type EventListView = EventListItemApiView & {
  teacher?: EventListItemApiView["teachers"][number];
  is_upcoming: boolean;
};

export function useEventList(filters?: EventFilters) {
  const cache = useEventCache();

  return useLazyFetch("/api/events", {
    query: filters,
    transform(data) {
      const views =
        data?.map((event) => {
          const view: EventListView = {
            ...event,
            teacher:
              event.teachers.length === 1 ? event.teachers[0] : undefined,
            is_upcoming: isFuture(new Date(event.start_date!)),
          };
          return view;
        }) ?? [];

      cache.setMultiple(views);

      return views;
    },
    default: () => [],
  });
}
